import graphql from 'babel-plugin-relay/macro';

export const LinkEmailSpamTestResultMutation = graphql`
  mutation LinkEmailSpamTestResultMutation($input: LinkEmailSpamTestResultMutationInput!) {
    linkEmailSpamTestResult(input: $input) {
      response
    }
  }
`;
